// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReadOutlinedSvg from "@fishx/icons-svg/es/asn/ReadOutlined";
import FishxIcon from '../components/FishxIcon';

var ReadOutlined = function ReadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReadOutlinedSvg
  }));
};

ReadOutlined.displayName = 'ReadOutlined';
export default React.forwardRef(ReadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ReadOutlined.js
// module id = 3969
// module chunks = 0